import PERMISSIONS from "rbac/Permissions.json";

export const ALL_CLIENT_OPTION = { label: "ALL", value: "ALL" };

export const PAW_LOAD_ACCESS_PERMISSIONS = [
  PERMISSIONS.PERM_PAW_GROUP_ADMIN_MANAGE,
  PERMISSIONS.PERM_PAW_LOAD_MANAGE,
];
